import { render, staticRenderFns } from "./AsideInfoBlock.vue?vue&type=template&id=53ffdcd0"
import script from "./AsideInfoBlock.vue?vue&type=script&lang=js"
export * from "./AsideInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports